import { dayjs } from "@lib";

/** Relative labels by day difference (not calendar week — avoids pt-br week-start edge cases). */
export function formatInsightCreatedAt(createdAt: string): string {
	const date = dayjs(createdAt).startOf("day");
	const today = dayjs().startOf("day");
	const diffDays = today.diff(date, "day");

	if (diffDays === 0) {
		return `Hoje, ${date.format("DD/MM")}`;
	}

	if (diffDays === 1) {
		return `Ontem, ${date.format("DD/MM")}`;
	}

	if (diffDays >= 2 && diffDays <= 6) {
		return date.format("DD/MM");
	}

	if (diffDays >= 7 && diffDays <= 13) {
		return `Semana passada, ${date.format("DD/MM")}`;
	}

	if (diffDays === -1) {
		return `Amanhã, ${date.format("DD/MM")}`;
	}

	if (diffDays <= -2 && diffDays >= -6) {
		return date.format("DD/MM");
	}

	if (diffDays <= -7 && diffDays >= -13) {
		return `Próxima semana, ${date.format("DD/MM")}`;
	}

	return date.format("DD/MM/YYYY");
}
